import type { Organization } from 'src/app/types';

export interface Default extends Partial<Organization> {
    channelCodes: NonNullable<Organization['channelCodes']>;
    marketCodes: NonNullable<Organization['marketCodes']>;
    types: NonNullable<Organization['types']>;
}

export const DEFAULT: Default = {
    channelCodes: [],
    marketCodes: [],
    types: [],
};